import { Parser } from 'html-to-react';
import React from 'react'
import { MdOutlineClose } from "react-icons/md";

const Warning = ({ isOpen, setIsOpen, position = 'absolute', text }: { isOpen: boolean, setIsOpen: React.Dispatch<React.SetStateAction<boolean>>, position?: 'absolute' | 'relative', text: string }) => {

  if (!isOpen) return null

  return (
    <div className='flex justify-center relative w-full'>
      <div className={`bg-[#2C3134] text-[#EDF1F5] ${position} z-10 flex items-start lg:items-center gap-12 p-3 rounded-md shadow-custom-dual w-full`}>
        <div className='text-bmedium w-full'>
          {Parser().parse(text)}
        </div>
        <button onClick={() => setIsOpen(!isOpen)} className="flex justify-end">
          <MdOutlineClose size={24} />
        </button>
      </div>
    </div>
  )
}

export default Warning